import React from 'react'
import ManageBooks from '../manage-books/ManageBooks'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'
import { useTranslation } from 'react-i18next'

type Props = {}

const ManageAudioBook: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation()
    return (
        <ManageBooks
            button_add_name={t("เพิ่มหนังสือเสียง")}
            category={ELibraryCategory.AUDIO_BOOK}
            menu_name={t('จัดการหนังสือเสียง')}
            path_create={routeName.e_library.manage_audio_book_create}
        />
    )
}

export default ManageAudioBook